<template>
<div>
  <mdc-textfield :value="value"
    @input="updateModel"
    :label="label"
    :name="myName"
    :type="type"
    :disabled="disabled"
    :class="{required: isRequired, 'is-danger': errors.has(myName) }"
    v-validate="validation" />
    <input-error :name="myName" />
</div>
</template>

<script>
export default {
  props: ['name', 'value', 'label', 'validate', 'type', 'disabled'],
  inject: ['$validator'],
  computed: {
    myName() {
      return this.name || this.label
    },
    validation() {
      return this.validate || false
    },
    isRequired() {
      return this.validate && this.validate.indexOf('required') > -1
    }
  },
  methods: {
    updateModel(value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/input-text.vue